import React from 'react';
import { MockupTool as MockupComponent } from '../../components/tools/MockupTool';
import { ResultViewer } from '../../components/ResultViewer';
import { useToolExecution } from '../../hooks/useToolExecution';
import { useDesign } from '../../context/DesignContext';
import { ToolHeader } from '../../components/ui/ToolHeader';
import { TOOL_COSTS } from '../../constants';

export const MockupTool = () => {
  const { checkCredits, deductCredits } = useToolExecution();
  const { setApiResult, apiResult, loading, setLoading } = useDesign();

  return (
    <div className="flex flex-col">
      <ToolHeader 
        title="Mockup Generator"
        cost={`${TOOL_COSTS.mockup} credits`}
        description={
          <>
            <p className="font-bold">Place designs on multiple products instantly.</p>
            <p>1. Upload "Base Images" (blank shirts, mugs) or choose from your <strong>Saved Templates</strong>.</p>
            <p>2. Upload your "Design File" (PNG).</p>
            <p>3. Set the SKU/Filename prefix. All generated images will be downloadable with this naming convention.</p>
          </>
        }
      />
      <div className="flex flex-col gap-6">
        <MockupComponent 
          onCostIncurred={(cost) => deductCredits(cost, 'Mockup')} 
          checkCredits={checkCredits} 
          onResult={setApiResult} 
          setLoading={setLoading}
          isLoading={loading}
        />
        {apiResult && (
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
            <h3 className="text-lg font-bold text-slate-900 mb-4">Generated Mockups</h3>
            <ResultViewer 
              success={apiResult.success} 
              error={apiResult.error} 
              images={apiResult.images} 
            />
          </div>
        )}
      </div>
    </div>
  );
};
